module.exports = "/_next/static/resources/photo-4-57c4396d1daa050f4e66b88057941fd1.jpg";